import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as $$JSON from "../JSON/index.js";
import * as JSON$dInternal from "../JSON.Internal/index.js";
const $Path = (tag, _1, _2) => ({tag, _1, _2});
const Tip = /* #__PURE__ */ $Path("Tip");
const AtKey = value0 => value1 => $Path("AtKey", value0, value1);
const AtIndex = value0 => value1 => $Path("AtIndex", value0, value1);
const showPath = {
  show: v => {
    if (v.tag === "Tip") { return "Tip"; }
    if (v.tag === "AtKey") { return "(AtKey " + Data$dShow.showStringImpl(v._1) + " " + showPath.show(v._2) + ")"; }
    if (v.tag === "AtIndex") { return "(AtIndex " + Data$dShow.showIntImpl(v._1) + " " + showPath.show(v._2) + ")"; }
    $runtime.fail();
  }
};
const genericPath_ = {
  to: x => {
    if (x.tag === "Inl") { return Tip; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $Path("AtKey", x._1._1._1, x._1._1._2); }
      if (x._1.tag === "Inr") { return $Path("AtIndex", x._1._1._1, x._1._1._2); }
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Tip") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "AtKey") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2))); }
    if (x.tag === "AtIndex") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Product(x._1, x._2))); }
    $runtime.fail();
  }
};
const eqPath = {
  eq: x => y => {
    if (x.tag === "Tip") { return y.tag === "Tip"; }
    if (x.tag === "AtKey") { return y.tag === "AtKey" && x._1 === y._1 && eqPath.eq(x._2)(y._2); }
    return x.tag === "AtIndex" && y.tag === "AtIndex" && x._1 === y._1 && eqPath.eq(x._2)(y._2);
  }
};
const ordPath = {
  compare: x => y => {
    if (x.tag === "Tip") {
      if (y.tag === "Tip") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Tip") { return Data$dOrdering.GT; }
    if (x.tag === "AtKey") {
      if (y.tag === "AtKey") {
        const v = Data$dOrd.ordString.compare(x._1)(y._1);
        if (v === "LT") { return Data$dOrdering.LT; }
        if (v === "GT") { return Data$dOrdering.GT; }
        return ordPath.compare(x._2)(y._2);
      }
      return Data$dOrdering.LT;
    }
    if (y.tag === "AtKey") { return Data$dOrdering.GT; }
    if (x.tag === "AtIndex" && y.tag === "AtIndex") {
      const v = Data$dOrd.ordInt.compare(x._1)(y._1);
      if (v === "LT") { return Data$dOrdering.LT; }
      if (v === "GT") { return Data$dOrdering.GT; }
      return ordPath.compare(x._2)(y._2);
    }
    $runtime.fail();
  },
  Eq0: () => eqPath
};
const stripPrefix = stripPrefix$a0$copy => stripPrefix$a1$copy => {
  let stripPrefix$a0 = stripPrefix$a0$copy, stripPrefix$a1 = stripPrefix$a1$copy, stripPrefix$c = true, stripPrefix$r;
  while (stripPrefix$c) {
    const v = stripPrefix$a0, v1 = stripPrefix$a1;
    if (v1.tag === "AtKey") {
      if (v.tag === "AtKey") {
        if (v._1 === v1._1) {
          stripPrefix$a0 = v._2;
          stripPrefix$a1 = v1._2;
          continue;
        }
        stripPrefix$c = false;
        stripPrefix$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Tip") {
        stripPrefix$c = false;
        stripPrefix$r = Data$dMaybe.$Maybe("Just", v1);
        continue;
      }
      stripPrefix$c = false;
      stripPrefix$r = Data$dMaybe.Nothing;
      continue;
    }
    if (v1.tag === "AtIndex" && v.tag === "AtIndex") {
      if (v._1 === v1._1) {
        stripPrefix$a0 = v._2;
        stripPrefix$a1 = v1._2;
        continue;
      }
      stripPrefix$c = false;
      stripPrefix$r = Data$dMaybe.Nothing;
      continue;
    }
    if (v.tag === "Tip") {
      stripPrefix$c = false;
      stripPrefix$r = Data$dMaybe.$Maybe("Just", v1);
      continue;
    }
    stripPrefix$c = false;
    stripPrefix$r = Data$dMaybe.Nothing;
  }
  return stripPrefix$r;
};
const print = path => {
  const go = p => {
    if (p.tag === "Tip") { return ""; }
    if (p.tag === "AtKey") { return "." + p._1 + go(p._2); }
    if (p.tag === "AtIndex") { return "[" + Data$dShow.showIntImpl(p._1) + "]" + go(p._2); }
    $runtime.fail();
  };
  return "$" + go(path);
};
const $$get = path => json => {
  if (path.tag === "Tip") { return Data$dMaybe.$Maybe("Just", json); }
  if (path.tag === "AtKey") {
    const $0 = $$get(path._2);
    const $1 = JSON$dInternal._case($$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, Data$dMaybe.Just, json);
    const $2 = (() => {
      if ($1.tag === "Just") { return JSON$dInternal._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, path._1, $1._1); }
      if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if ($2.tag === "Just") { return $0($2._1); }
    if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  }
  if (path.tag === "AtIndex") {
    const $0 = $$get(path._2);
    const $1 = JSON$dInternal._case($$JSON.fail, $$JSON.fail, $$JSON.fail, $$JSON.fail, Data$dMaybe.Just, $$JSON.fail, json);
    const $2 = (() => {
      if ($1.tag === "Just") { return JSON$dInternal._index(Data$dMaybe.Nothing, Data$dMaybe.Just, path._1, $1._1); }
      if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    if ($2.tag === "Just") { return $0($2._1); }
    if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
  }
  $runtime.fail();
};
const findCommonPrefix = v => v1 => {
  if (v.tag === "AtKey") {
    if (v1.tag === "AtKey" && v._1 === v1._1) { return $Path("AtKey", v._1, findCommonPrefix(v._2)(v1._2)); }
    return Tip;
  }
  if (v.tag === "AtIndex" && v1.tag === "AtIndex" && v._1 === v1._1) { return $Path("AtIndex", v._1, findCommonPrefix(v._2)(v1._2)); }
  return Tip;
};
const extend = p1 => p2 => {
  if (p1.tag === "Tip") { return p2; }
  if (p1.tag === "AtKey") { return $Path("AtKey", p1._1, extend(p1._2)(p2)); }
  if (p1.tag === "AtIndex") { return $Path("AtIndex", p1._1, extend(p1._2)(p2)); }
  $runtime.fail();
};
export {$Path, AtIndex, AtKey, Tip, eqPath, extend, findCommonPrefix, genericPath_, $$get as get, ordPath, print, showPath, stripPrefix};
